import React from "react";
import { getCurrentUrl } from "../data/common";
/* share imports */
import {
  WhatsappIcon,
  WhatsappShareButton,
  // EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  // FacebookMessengerIcon,
  // FacebookMessengerShareButton,
  TwitterShareButton,
  XIcon,
} from "react-share";
import { toast } from "react-toastify";
import { mediaData } from "../data/mediaData";

const ShareComponentWrapper = ({ callGaHandler, storyHeadText, showShareComponentHandler }) => {
  const shareClickHandler = (fromSource) => {
    callGaHandler("Share_source", fromSource);
    callGaHandler("Share_story", storyHeadText);
  };

  const seoMetaInfo = {
    title: "Check out Curvv.ev's sleek new look!",
    subject: "Check out Curvv.ev's sleek new look!",
    body: "Check out Curvv.ev's sleek new look!",
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        toast.success("Link copied!");
        showShareComponentHandler();
      })
      .catch((error) => {
        console.error('Error copying text:', error);
      });
  };

  return (
    <div className="share-component-wrapper">
      <div
        className="share-icon-wrapper"
        onClick={() => shareClickHandler("Copy_Link")}
      >
        <button onClick={() => handleCopy(getCurrentUrl())} className="share-icon-button">
          <img src={mediaData['copyLink']} alt="copy link" width={32} />
        </button>
      </div>
      <div
        className="share-icon-wrapper"
        onClick={() => shareClickHandler("Whatsapp")}
      >
        <WhatsappShareButton
          url={getCurrentUrl()}
          title={seoMetaInfo.title}
          separator=": "
        >
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </div>
      <div
        className="share-icon-wrapper"
        onClick={() => shareClickHandler("Facebook")}
      >
        <FacebookShareButton url={getCurrentUrl()}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
      </div>
      {/* <div
        className="share-icon-wrapper"
        onClick={() => shareClickHandler("Facebook_Messenger")}
      >
        <FacebookMessengerShareButton
          url={getCurrentUrl()}
          //   appId="521270401588372"
        >
          <FacebookMessengerIcon size={32} round />
        </FacebookMessengerShareButton>
      </div> */}

      <div
        className="share-icon-wrapper"
        onClick={() => shareClickHandler("Twitter")}
      >
        <TwitterShareButton url={getCurrentUrl()} title={seoMetaInfo.title}>
          <XIcon size={32} round />
        </TwitterShareButton>
      </div>
      <div
        className="share-icon-wrapper"
        onClick={() => shareClickHandler("Email")}
      >
        <EmailShareButton
          url={getCurrentUrl()}
          subject={seoMetaInfo.title}
          body={seoMetaInfo.body}
        >
          <img src={mediaData['mailIcon']} alt="copy link" width={32} />
        </EmailShareButton>
      </div>
    </div>
  );
};

export default ShareComponentWrapper;
